import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';

import { MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';

@Component({
    selector: 'custom-snackbar',
    template: ` <div class="snackbar-content">
    <table>
      <tr>
        <td>
          <span>{{ data.message }}</span>
          <a href="{{ data.link }}" target="_blank" style="padding-left:2px"
            ><b>{{ data.linkText }}</b></a
          >
        </td>
        <td>
          <button mat-button color="primary" (click)="dismiss()" class="close-button">X</button>
        </td>
      </tr>
    </table>
  </div>`,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class CustomSnackBarComponent {
  constructor(
    @Inject(MAT_SNACK_BAR_DATA) public data: { message: string; link: string; linkText: string; preClose: () => void },
  ) {}

  dismiss(): void {
    this.data.preClose();
  }
}
